<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Multiselect from '@/components/Multiselect/main.vue';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';

import { masterMethods, prizeMethods, clientMethods } from '@/state/helpers';
import { checkPermission, checkPermissionName } from '@/utils/handlers';
import { InputCheckBox } from '@/components/Input';
import { state } from '@/state/modules/authfack';
import { isRolePartner } from '@/views/pages/require/handlers.js';

export default {
    page: {
        title: '賞品管理一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        KeyWordTag,
        Layout,
        Multiselect,
        InputCheckBox,
        TableListComponent,
        ButtonActiveFilter
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('prize.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            listData: [],
            listDataCampaign: [],
            listTagFreeWord: [],
            listTagKeyWord: [],
            form: {
                name: '',
                remaining_quantity: ''
            },
            has: {
                campaign: '',
                partner: isRolePartner() ? state.user.partner_id ?? '' : ''
            },
            filter: {
                type: '',
                quantity: '',
                other_than_zero: ''
            },
            date_from: {
                quantity: ''
            },
            configKeyword: {
                arrayTag: [],
                placeholder: 'キャンペーン名　賞品名 ...',
                isShowLable: true
            },
            configTable: {
                widthAction: 100,
                headers: [
                    {
                        label: 'キャンペーン名',
                        width: 400
                    },
                    {
                        label: '賞品タイトル',
                        width: 200
                    },
                    {
                        label: '賞品名',
                        width: 100
                    },
                    {
                        label: '数量',
                        width: 100
                    },
                    {
                        label: '賞品必要数',
                        width: 100
                    }
                ]
            },
            configPage: {
                total: 0,
                limit: 30,
                page: 1
            },

            campaign: null,
            checkShowFilter: false,
            isLoading: false,

            isActive: true,
            heightSizeTable: ''
        };
    },
    watch: {
        campaign: function (newName) {
            this.has.campaign = newName?.id ?? '';
        },

        'configKeyword.arrayTag': function (newOld) {
            if (!this.checkShowFilter) {
                this.listTagFreeWord = newOld;
            } else {
                this.listTagKeyWord = newOld;
            }
        }
    },
    mounted() {
        this.getListCampaign();
        this.getList();
    },

    methods: {
        checkPermission,
        checkPermissionName,
        ...masterMethods,
        ...prizeMethods,
        ...clientMethods,

        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
            if (this.checkShowFilter) {
                this.configKeyword.placeholder = '';
                this.configKeyword.arrayTag = this.listTagKeyWord;
            } else {
                this.configKeyword.placeholder = 'キャンペーン名　賞品名 ...';
                this.configKeyword.arrayTag = this.listTagFreeWord;
            }
        },

        getListCampaign() {
            let query = 'all/campaigns';
            if (isRolePartner()) {
                query += `?has[partner]=${this.has.partner}`;
            }
            this.listMaster(query).then((data) => {
                this.listDataCampaign = data;
            });
        },

        goToEdit(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];

            if (this.has) {
                for (const [key, value] of Object.entries(this.has)) {
                    if (key && value) query.push(`has[${key}]=${value}`);
                }
            }

            if (this.checkShowFilter) {
                if (this.form) {
                    for (const [key, value] of Object.entries(this.form)) {
                        if (key && value) query.push(`search[${key}]=${value}`);
                    }
                }

                if (this.filter) {
                    for (const [key, value] of Object.entries(this.filter)) {
                        if (key && value) query.push(`filters[${key}]=${value}`);
                    }
                }

                if (this.date_from) {
                    let date_from = Object.assign({}, this.date_from);
                    for (const [key, value] of Object.entries(date_from)) {
                        if (key && value) {
                            if (key == 'remaining_quantity') {
                                query.push(`from[${key}]=1`);
                            } else {
                                query.push(`from[${key}]=${value}`);
                            }
                        }
                    }
                }
            } else {
                if (this.configKeyword.arrayTag.length > 0) {
                    query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                }
            }
            return query.join('&');
        },
        getList() {
            this.isLoading = true;
            let query = this.getQueryString();
            this.listPrize(query).then((data) => {
                this.listData = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listData.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            });
        },

        search() {
            this.getList();
        },
        clear() {
            this.configKeyword = {
                arrayTag: [],
                placeholder: 'キャンペーン名名　賞品名 ...',
                isShowLable: true
            };

            this.form = {
                name: '',
                remaining_quantity: ''
            };
            this.has = {
                campaign: '',
                partner: isRolePartner() ? state.user.partner_id ?? '' : ''
            };
            this.filter = {
                type: '',
                remaining_quantity: '',
                other_than_zero: ''
            };
            this.campaign = null;
            this.getList();
        },
        goToViewCampaign(path, id) {
            this.$router.push({ path: path, query: { id: id } });
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row form__common--center">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex" style="gap: 0.5rem">
                        <h3 class="mb-0 title--screen">賞品検索</h3>
                        <div class="ml-auto">
                            <ButtonActiveFilter
                                :active.sync="isActive"
                                @sizeHeight="(height) => (heightSizeTable = height)"
                                :smallCol="577"
                                :largeCol="53.9"
                            />
                        </div>
                    </div>
                    <div v-if="isActive" class="card-body position-relative">
                        <div class="row justify-content-center">
                            <div class="col-sm-6 position-static">
                                <form class="needs-validation" autocomplete="off">
                                    <div v-if="!checkShowFilter" class="row form-group">
                                        <div class="col-sm-12">
                                            <KeyWordTag :config="configKeyword" class="" />
                                        </div>
                                    </div>

                                    <div v-if="checkShowFilter">
                                        <div class="form-group row" v-if="!checkPermissionName(['partner'])">
                                            <label class="col-sm-3" for="validationCustom05">賞品名</label>
                                            <div class="col-sm-9">
                                                <input id="validationCustom05" v-model="form.name" type="text" class="form-control" />
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <label class="col-sm-3" for="validationCustom05">キャンペーン名</label>
                                            <div class="col-sm-9">
                                                <Multiselect
                                                    :id="`select-campaign-default`"
                                                    :value.sync="campaign"
                                                    :options="listDataCampaign"
                                                    :config="{
                                                        trackBy: 'id',
                                                        label: 'name',
                                                        error: false,
                                                        isRemove: false
                                                    }"
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <label class="col-sm-3" for="validationCustom05">数量</label>
                                            <div class="col-sm-9">
                                                <div class="d-flex align-items-center">
                                                    <input
                                                        id="validationCustom05"
                                                        v-model="filter.quantity"
                                                        type="text"
                                                        style="width: 180px"
                                                        class="form-control"
                                                    />
                                                    <div>
                                                        <InputCheckBox
                                                            class="ml-4"
                                                            :model.sync="date_from.quantity"
                                                            :id="`checkd`"
                                                            :value="1"
                                                            :label="`0以外`"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="text-center mt-4">
                                        <button type="button" @click="clear()" class="btn btn-common btn-outline-primary">
                                            <i class="ri-restart-line"></i>クリア
                                        </button>
                                        <button type="button" @click="search()" class="btn btn-common btn-primary ml-3">
                                            <i class="ri-search-line"></i>検索
                                        </button>
                                        <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                            <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-0">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">
                            賞品検索結果 <span>件数（{{ configPage.total }})</span>
                        </h3>
                    </div>
                    <div class="card-body">
                        <TableListComponent
                            :heightTable="heightSizeTable"
                            :config="configTable"
                            :dataList="listData"
                            :isLoading="isLoading"
                            :configPage.sync="configPage"
                            :stickyAction="true"
                            @onChangePage="getList()"
                        >
                            <template #row="{ row }">
                                <tr @dblclick="goToEdit('/prize/form', row)">
                                    <td class="text-left">
                                        <div class="el-table__cell" v-b-tooltip.hover :title="row.campaign_event_prize?.campaign?.name ?? ''">
                                            <a
                                                href="javascript:void(0)"
                                                @click="goToViewCampaign('/campaign/form/view', row.campaign_event_prize?.campaign?.id ?? '')"
                                                v-if="checkPermission('campaign.view')"
                                            >
                                                {{ row.campaign_event_prize?.campaign?.name ?? '' }}</a
                                            >
                                            <span v-else>{{ row.campaign_event_prize?.campaign?.name ?? '' }}</span>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="el-table__cell text-left" v-b-tooltip.hover :title="row.campaign_event_prize?.title ?? ''">
                                            {{ row?.campaign_event_prize?.title ?? '' }}
                                        </div>
                                    </td>

                                    <td>
                                        <div class="el-table__cell text-left" v-b-tooltip.hover :title="row?.name ?? ''">
                                            {{ row?.name ?? '' }}
                                        </div>
                                    </td>

                                    <td class="el-table__cell text-left">
                                        {{ row.quantity }}
                                    </td>
                                    <td class="el-table__cell text-left">{{ row.quantity_for_event_prize }}</td>

                                    <td :align="'center'" class="sticky_action text-left" style="z-index: 15">
                                        <a href="javascript:void(0)" class="btn btn-sm btn-info mr-2" @click="goToEdit('/prize/form/view', row)"
                                            >詳細</a
                                        >
                                        <a
                                            v-if="checkPermission('prize.edit')"
                                            href="javascript:void(0)"
                                            class="btn btn-sm btn-success"
                                            @click="goToEdit('/prize/form', row)"
                                            >編集</a
                                        >
                                    </td>
                                </tr>
                            </template>
                        </TableListComponent>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
td,
th {
    vertical-align: middle;
}
</style>
